import { makeMinionCard } from '../../cards/make-minion';

export const SoldiersCard = makeMinionCard({
    name: "Soldier",
    power: 2,
    summonedCount: 2,
    goldCost: 1
});